import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserPlus } from 'lucide-react';

const RegisterPage = () => {
    const [formData, setFormData] = useState({
        prenom: '', nom: '', email: '', telephone: '', password: '', confirmPassword: ''
    });
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const { register, error } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            alert('Les mots de passe ne correspondent pas.');
            return;
        }
        setSubmitting(true);
        try {
            await register({
                prenom: formData.prenom,
                nom: formData.nom,
                email: formData.email,
                telephone: formData.telephone,
                password: formData.password,
                role: 'PARENT'
            });
            setSuccess(true);
            setTimeout(() => navigate('/login'), 2000);
        } catch {
            // géré dans AuthContext
        } finally {
            setSubmitting(false);
        }
    };

    if (success) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-primary-light via-white to-green-50 flex items-center justify-center p-4">
                <div className="card text-center shadow-xl border-0 max-w-md w-full">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <span className="text-3xl">✅</span>
                    </div>
                    <h2 className="text-gray-900 mb-2">Compte créé !</h2>
                    <p className="text-gray-600">Vous allez être redirigé vers la page de connexion...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-primary-light via-white to-green-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-2xl shadow-lg mb-4">
                        <span className="text-white text-2xl font-bold">TC</span>
                    </div>
                    <h1 className="text-3xl font-bold text-gray-900">TCVGD</h1>
                    <p className="text-gray-500 mt-1">Créer un compte Parent</p>
                </div>

                <div className="card shadow-xl border-0">
                    <h2 className="text-center text-gray-800 mb-6">Inscription</h2>

                    {error && (
                        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Prénom</label>
                                <input name="prenom" value={formData.prenom} onChange={handleChange} className="input" placeholder="Jean" required />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Nom</label>
                                <input name="nom" value={formData.nom} onChange={handleChange} className="input" placeholder="Dupont" required />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <input type="email" name="email" value={formData.email} onChange={handleChange} className="input" placeholder="jean@email.com" required />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Téléphone</label>
                            <input type="tel" name="telephone" value={formData.telephone} onChange={handleChange} className="input" placeholder="079 123 45 67" />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Mot de passe</label>
                            <input type="password" name="password" value={formData.password} onChange={handleChange} className="input" placeholder="Min. 8 caractères" required minLength={8} />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Confirmer le mot de passe</label>
                            <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="input" placeholder="••••••••" required />
                        </div>

                        <button
                            type="submit"
                            disabled={submitting}
                            className="btn-primary w-full flex items-center justify-center gap-2 py-3 disabled:opacity-60"
                        >
                            {submitting ? (
                                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                            ) : (
                                <UserPlus className="w-5 h-5" />
                            )}
                            {submitting ? 'Création...' : "Créer mon compte"}
                        </button>
                    </form>

                    <div className="mt-6 text-center">
                        <p className="text-gray-600 text-sm">
                            Déjà un compte ?{' '}
                            <Link to="/login" className="text-primary font-medium hover:underline">Se connecter</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;
